// for DEV
export const DEV_CONFIGS = {
  backend_port: "", // define the backend port
  // backend_port: ":5080", // define the backend port
  backend_url_path: "/api/", // custom backend url path if necessary. default is "/"
  route_basename: "/", // for defining the base route for BrowserRouter
};
